import React, { Component } from 'react'
import { AppContext, AccountFeatures } from '@lightspeed-invoicing/core-client/frontend';
import { Link } from 'react-router-dom'
import { FormattedDate, FormattedMessage, FormattedNumber, FormattedTime } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import Pagination from "../common/listing/pagination.component.jsx";
import EventBus from "../common/EventBus.js";
import SortLink from "../common/listing/sortlink.component.jsx";
import CalendarEventStatusBadge from "../scheduling-page/calendareventstatusbadge.component.jsx";
import CalendarModal from '../calendar/modals/CalendarModal.component.jsx';
import Icon from "../common/icon/icon.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';

class CalendarEventListByContact extends Component {

    constructor(props, context) {
        super(props, context)

        const contactId = this.props.contactId || ''
        this.state = {
            contactId: contactId,
            contactType: '',
            customerName: this.props.customerName || '',
            customerAccountIds: [],
            headers: [],
            rows: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            customerAccount: null,
            noEmployee: false,
            modal: '',
            sortField: 'startAt',
            asc: false,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.refreshCustomerAccount = this.refreshCustomerAccount.bind(this)
        this.loadCalendarEventsByContactId = this.loadCalendarEventsByContactId.bind(this)
        this.refreshCalendarEventList = this.refreshCalendarEventList.bind(this)
        this.handleSortLinkChange = this.handleSortLinkChange.bind(this)
        this.openEventCreationModal = this.openEventCreationModal.bind(this)
    }

    componentDidMount() {
        if (this.state.contactId) {
            this.refreshCustomerAccount(this.state.contactId)
        }
    }
    componentWillReceiveProps(nextProps) {
        this.refreshCustomerAccount(nextProps.contactId)
    }

    refreshCustomerAccount(contactId) {
        if (!contactId) {
            contactId = this.state.contactId
        }
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            const noEmployee = res.attributes.contact.type === 'organizations' && !res.attributes.contact.attributes.primaryContactId
            this.setState({
                customerAccount: res,
                noEmployee: noEmployee,
                contactId: contactId,
                customerAccountIds: res.attributes.customerAccountIds || [],
                contactType: res.attributes.contactType || '',
            }, this.loadCalendarEventsByContactId)
        })
    }

    handleSortLinkChange(sortField, asc) {
        this.setState({
            sortField: sortField,
            asc: asc,
        }, () => {
            this.loadCalendarEventsByContactId()
        })
    }

    headers() {
        let headers = []
        if (this.state.contactType === 'organizations') {
            headers.push(<FormattedMessage
                id="customers.events.list.headers.employee_label"
                defaultMessage="Employee"
            />)
        }
        return headers.concat([
            < SortLink
                field={'id'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.id_label"
                    defaultMessage="ID"
                />
            </SortLink >,
            < SortLink
                field={'locationNameSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.location_label"
                    defaultMessage="Location"
                />
            </SortLink >,
            < SortLink
                field={'titleSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.title_label"
                    defaultMessage="Title"
                />
            </SortLink >,
            < SortLink
                field={'startAt'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.start_at_label"
                    defaultMessage="Start at"
                />
            </SortLink >,
            < SortLink
                field={'endAt'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.end_at_label"
                    defaultMessage="End at"
                />
            </SortLink >,
            < SortLink
                field={'user.nameSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.assigned_to_label"
                    defaultMessage="Assigned to"
                />
            </SortLink >,
            <FormattedMessage
                id="scheduling_page.events.listing.headers.status_label"
                defaultMessage="Status"
            />,
        ])
    }

    row(calendarEvent) {
        let rows = [
            <Link to={'/calendar-events/' + calendarEvent.id + '/edit'}>
                {calendarEvent.identifier}
            </Link>
        ]
        if (this.state.contactType === 'organizations') {
            rows.push(calendarEvent.contact ?
                <Link className={calendarEvent.contact.isArchived ? "text-danger" : ""} to={'/contacts/' + calendarEvent.contactId + '/details'}>
                    {calendarEvent.contact.name}
                </Link> : '-')
        }
        return rows.concat([
            calendarEvent.locationName,
            calendarEvent.title,
            calendarEvent.startAt ? [<div><FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(calendarEvent.startAt)} /></div>,
            <FormattedTime value={new Date(calendarEvent.startAt)} />] : '-',
            calendarEvent.endAt ? [<div><FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(calendarEvent.endAt)} /></div>,
            <FormattedTime value={new Date(calendarEvent.endAt)} />] : '-',
            calendarEvent.user.name,
            <CalendarEventStatusBadge status={calendarEvent.status} />,
        ])
    }

    loadCalendarEventsByContactId() {
        let postData = {
            keywords: '*',
            objects: ['calendar-events'],
            fields: ['contact.name'],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: this.state.sortField,
            sortAsc: this.state.asc,
            filters: {
                contactId: this.state.customerAccountIds,
            },
            lightResult: true,
        }

        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }

    refreshCalendarEventList() {
        this.setState({
            activePage: 1,
        }, this.loadCalendarEventsByContactId)
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, this.loadCalendarEventsByContactId)
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.refreshCustomerAccount(this.state.contactId)
        setTimeout(this.refreshCustomerAccount, 2000)
        EventBus.dispatch(EventBus.TopicRefreshCustomerDetails, {
            contactId: this.state.contactId,
        })
    }

    openEventCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <CalendarModal
                contactId={this.state.contactId}
                userId={AppContext.getUserLoggedIn().id}
                onClose={() => {
                    setTimeout(this.refreshCalendarEventList, 1000);
                    this.setState({
                        modal: '',
                    })
                }}
            />
        })
    }

    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                {this.state.modal}
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={this.state.headers}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        <div>
                            <ButtonWrapper
                                onClick={(e) => this.openEventCreationModal(e)}
                                className={"btn btn-primary btn-sm"}
                                protectedClassName={"btn btn-primary btn-sm"}
                                redirectToAccount={true}
                                premium={false}
                                protectionRule={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureScheduling)}>
                                <Icon value={'plus-circle'} className={'mr-1'} />
                                <FormattedMessage
                                    id="customers.events.list.new_event_btn"
                                    defaultMessage="New event"
                                />
                            </ButtonWrapper>
                        </div>
                    </div>}
                />
            </div>

        );
    }
}

export default CalendarEventListByContact





// WEBPACK FOOTER //
// ./src/customer/calendareventlist.component.jsx